<template>
    <slot v-bind="{
        ...state,
        isDisabled: props.isDisabled,
        handleClick,
    }" />
</template>

<script setup>
import { onBeforeMount, onBeforeUnmount, onMounted, reactive } from 'vue';

import favorites from '../services/favorites';
import zonedDate from '../utils/zoned-date';
import { isValid } from 'date-fns';

const now = zonedDate();

const props = defineProps({
    id: {
        type: [ Number, String ],
        default: null,
    },
    date: {
        type: [ Date, String ],
        default: null,
    },
    isDisabled: {
        type: Boolean,
        default: false,
    },
});

const state = reactive({
    isProcessing: false,
    performance: null,
    isFavorited: false,
});

const handleClick = () => {
    state.isProcessing = true;

    if (state.isFavorited) {
        favorites.unfavoritePerformance(state.performance);
        state.isFavorited = false;
    } else {
        favorites.favoritePerformance(state.performance);
        state.isFavorited = true;
    }

    state.isProcessing = false;
}

const handleFavoritesChange = () => {
    if (state.performance) {
        state.isFavorited = favorites.isFavoritePerformance(state.performance);
    }
}

onBeforeMount(() => {
    const id = parseInt(props.id, 10);
    const date = props.date instanceof Date ? props.date : zonedDate(props.date);

    if (!id || !isValid(date) || date < now) {
        return;
    }

    state.performance = {
        id,
        date,
    }

    state.isFavorited = favorites.isFavoritePerformance(state.performance);
});

onMounted(() => {
    window.addEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});

onBeforeUnmount(() => {
    window.removeEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});
</script>
